import React from 'react';

const Vue_v_once = () => {
  return (
    <div>
      <h1>Vue_v_once Component</h1>
      <p>This is the Vue_v_once tutorial page.</p>
    </div>
  );
}

export default Vue_v_once;
